<template>
  <div class="feeBill">
    <!-- 查询区域 -->
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="searchBatchNo"
            placeholder="票据批次号"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    
    <!-- 列表区域 -->
    <el-card>
      <el-button type="primary" slot="header" v-if="isFeeManager===1" @click="add">新增票据</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="id" :label="'ID'" v-if="false"></el-table-column>
        <el-table-column prop="billType" label="票据类型">{{"收据"}}</el-table-column>
        <el-table-column prop="billPrefix" label="票据前缀"></el-table-column>
        <el-table-column prop="startNo" label="起始编号"></el-table-column>
        <el-table-column prop="endNo" label="截止编号"></el-table-column>
        <el-table-column prop="batchNo" label="票据批次号"></el-table-column>
        <el-table-column prop="createTime" label="登记日期">
          <template slot-scope="scope">{{ scope.row.createTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column v-if="isFeeManager===1" width="150" prop="operation" :label="$t('lang.lab_operation')">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" v-if="isFeeManager===1" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    
    <!-- 新增票据对话框 -->
    <el-dialog
      title="新增票据"
      :visible.sync="isAddDialog"
      :close-on-click-modal="false"
      center
      width="800px"
      @closed="handleAddDialogClosed"
    >
      <el-form
        :model="addForm"
        :rules="addRules"
        ref="addForm"
        :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="票据前缀" prop="billPrefix">
              <el-input
                placeholder="请输入票据前缀"
                v-model="addForm.billPrefix"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="票据批次号" prop="batchNo">
              <el-input
                placeholder="请输入票据批次号"
                v-model="addForm.batchNo"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="起始编号" prop="startNo">
              <el-input-number
                v-model="addForm.startNo"
                :min="0"
                :precision="0"
                placeholder="请输入起始编号"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截止编号" prop="endNo">
              <el-input-number
                v-model="addForm.endNo"
                :min="0"
                :precision="0"
                placeholder="请输入截止编号"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 所属小区 -->
        <el-form-item :label="$t('lang.diaFormgarden')" prop="gardenFeeId">
          <el-select
            v-model="addForm.gardenId"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')"
            class="select"
          >
            <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" value></el-option>
            <el-option
              v-for="item in gardenDialist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="所属项目" prop="gardenId"> -->
          <!-- <el-popover
            placement="bottom-start"
            trigger="manual"
            v-model="gardenPopoverVisible"
            width="300"
          >
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="gardenFilterText"
              size="small"
              style="margin-bottom: 8px"
            ></el-input> -->
            <!-- <el-tree
              :data="gardenAreaByStaff"
              :props="defaultProps"
              :filter-node-method="filterGardenNode"
              ref="gardenTree"
              @node-click="handleGardenNodeClick"
              :default-expanded-keys="gardenExpandedKeys"
              node-key="name"
              :highlight-current="true"
              :expand-on-click-node="true"
              accordion
            ></el-tree> -->
            <!-- <el-select
              slot="reference"
              v-model="addForm.gardenId"
              placeholder="请选择所属项目"
              @focus="gardenPopoverVisible = true"
              style="width: 100%"
            >
              <el-option
                v-for="item in flatGardenList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-popover> -->
        <!-- </el-form-item> -->
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
            v-model="addForm.remark"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearAddForm">取消</el-button>
        <el-button type="primary" @click="saveAdd">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 编辑票据对话框 -->
    <el-dialog
      title="编辑票据"
      :visible.sync="isEditDialog"
      :close-on-click-modal="false"
      center
      width="1200px"
      @closed="handleEditDialogClosed"
    >
      <div class="edit-header">
        <div class="stats-info">
          <span>总数/已用：{{ billStats.total }}/{{ billStats.used }}</span>
          <span style="margin-left: 20px;">已开金额：{{ billStats.totalAmount || '0.00' }}</span>
        </div>
      </div>
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="票据本信息" name="billInfo">
          <el-form
            :model="editForm"
            :rules="editRules"
            ref="editForm"
            :label-width="require('@/config/enum').c_ws8"
            :label-suffix="require('@/config/enum').c_colon"
          >
            <el-row :gutter="20">
              <!-- <el-col :span="12">
                <el-form-item label="票据类型">
                  <el-input v-model="editForm.billType" disabled></el-input>
                </el-form-item>
              </el-col> -->
               <el-col :span="12">
                <el-form-item label="票据批次号">
                  <el-input v-model="editForm.batchNo" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="票据前缀">
                  <el-input v-model="editForm.billPrefix" ></el-input>
                </el-form-item>
              </el-col>
              
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="起始编号">
                  <el-input v-model="editForm.startNo" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="截止编号">
                  <el-input v-model="editForm.endNo" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <!-- <el-col :span="12">
                <el-form-item label="票据位数">
                  <el-select v-model="editForm.billDigit" disabled style="width: 100%">
                    <el-option label="千位" :value="4"></el-option>
                    <el-option label="万位" :value="5"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
             
            </el-row>
            <!-- 所属小区 -->
            <el-form-item :label="$t('lang.diaFormgarden')" prop="gardenFeeId">
              <el-select
                v-model="editForm.gardenId"
                :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')"
                class="select"
              >
                <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" value></el-option>
                <el-option
                  v-for="item in gardenDialist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="4"
                v-model="editForm.remark"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="登记人">
              <el-input v-model="editForm.creatorName" disabled></el-input>
            </el-form-item>
            <el-form-item label="登记日期">
              <el-input v-model="editForm.createTimeStr" disabled></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="票据明细" name="billDetail">
          <el-tabs v-model="detailTab" @tab-click="handleDetailTabClick">
            <el-tab-pane label="所有票据" name="all">
              <el-table
                :data="detailTableData"
                class="wid100"
                @selection-change="handleDetailSelectionChange"
                :height="400"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  type="index"
                  :index="detailIndexMethod"
                  align="center"
                  label="序号"
                  width="100px"
                ></el-table-column>
                <el-table-column prop="billNo" label="票据编号"></el-table-column>
                <el-table-column prop="status" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status === 0">未开票</span>
                    <span v-else-if="scope.row.status === 1">已开票</span>
                    <span v-else-if="scope.row.status === 2">已作废</span>
                  </template>
                </el-table-column>
                <el-table-column prop="drawAmount" label="开票金额">
                  <template slot-scope="scope">
                    {{ scope.row.drawAmount || '0.00' }}
                  </template>
                </el-table-column>
                <el-table-column prop="drawerName" label="开票人"></el-table-column>
                <el-table-column prop="drawDate" label="开票日期">
                  <template slot-scope="scope">
                    {{ scope.row.drawDate | timeYMD }}
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px; display: flex; justify-content: space-between; align-items: center;">
                <!-- <div v-if="selectedDetailRows.length > 0">
                  <el-button type="danger" @click="voidBillDetail">作废</el-button>
                </div> -->
                <el-pagination
                  @size-change="handleDetailSizeChange"
                  @current-change="handleDetailCurrentChange"
                  :current-page="detailPageNo"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="detailPageSize"
                  layout="sizes, prev, pager, next, jumper"
                  :page-count="detailPageCount"
                  :total="detailTotal"
                  style="margin-left: auto;"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="已作废" name="voided">
              <el-table
                :data="voidedTableData"
                class="wid100"
                @selection-change="handleVoidedSelectionChange"
                :height="400"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  type="index"
                  :index="voidedIndexMethod"
                  align="center"
                  label="序号"
                  width="100px"
                ></el-table-column>
                <el-table-column prop="billNo" label="票据编号"></el-table-column>
                <el-table-column prop="status" label="状态">
                  <template slot-scope="scope">
                    <span>已作废</span>
                  </template>
                </el-table-column>
                <el-table-column prop="drawAmount" label="开票金额">
                  <template slot-scope="scope">
                    {{ scope.row.drawAmount || '0.00' }}
                  </template>
                </el-table-column>
                <el-table-column prop="drawerName" label="开票人"></el-table-column>
                <el-table-column prop="drawDate" label="开票日期">
                  <template slot-scope="scope">
                    {{ scope.row.drawDate | timeYMD }}
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px; display: flex; justify-content: space-between; align-items: center;">
                <!-- <div v-if="selectedVoidedRows.length > 0">
                  <el-button type="primary" @click="cancelVoidBillDetail">取消作废</el-button>
                </div> -->
                <el-pagination
                  @size-change="handleVoidedSizeChange"
                  @current-change="handleVoidedCurrentChange"
                  :current-page="voidedPageNo"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="voidedPageSize"
                  layout="sizes, prev, pager, next, jumper"
                  :page-count="voidedPageCount"
                  :total="voidedTotal"
                  style="margin-left: auto;"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearEditForm">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
        <el-button type="primary" @click="saveEditAndReturn">保存&返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import pinyin from 'pinyin'

/**
 * @ClassName:feeBill 票据管理
 * @Description:票据管理
 * @author:
 * @Copyright:格众科技
 * @date:2026
 */
export default {
  name: '/manage/main.feeBill',
  data() {
    var chooseGardenId = (rule, value, callback) => {
      if (!this.addForm || this.addForm.gardenId === '' || this.addForm.gardenId === null || this.addForm.gardenId === undefined) {
        callback(
          new Error(
            this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormgardenId')
          )
        )
      } else {
        callback()
      }
    }
    var chooseGardenIdEdit = (rule, value, callback) => {
      if (!this.editForm || this.editForm.gardenId === '' || this.editForm.gardenId === null || this.editForm.gardenId === undefined) {
        callback(
          new Error(
            this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormgardenId')
          )
        )
      } else {
        callback()
      }
    }
    return {
      gardenDialist: [], // 弹框的小区列表
      isFeeManager: 0,
      zero: 0,
      multipleSelection: [],
      pageCount: 0,
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      searchBatchNo: '',
      editId: '',
      isAddDialog: false,
      isEditDialog: false,
      activeTab: 'billInfo',
      detailTab: 'all',
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox,
      gardenId: 0,
      
      // 新增表单
      addForm: {
        billPrefix: '',
        batchNo: '',
        startNo: 0,
        endNo: 0,
        gardenId: '',
        remark: ''
      },
      addRules: {
        billPrefix: [
          { required: true, message: '请输入票据前缀', trigger: 'blur' }
        ],
        batchNo: [
          { required: true, message: '请输入票据批次号', trigger: 'blur' }
        ],
        startNo: [
          { required: true, message: '请输入起始编号', trigger: 'blur' }
        ],
        endNo: [
          { required: true, message: '请输入截止编号', trigger: 'blur' }
        ],
        gardenFeeId: [
          {
            required: true,
            validator: chooseGardenId,
            trigger: 'change',
          },
        ]
      },
      
      // 编辑表单
      editForm: {
        id: '',
        billType: '',
        billPrefix: '',
        startNo: '',
        endNo: '',
        billDigit: 4,
        batchNo: '',
        gardenId: '',
        gardenName: '',
        remark: '',
        creator: '',
        creatorName: '',
        createTime: '',
        createTimeStr: ''
      },
      editRules: {
        gardenFeeId: [
          {
            required: true,
            validator: chooseGardenIdEdit,
            trigger: 'change',
          },
        ]
      },
      
      // 统计信息
      billStats: {
        total: 0,
        used: 0,
        totalAmount: '0.00'
      },
      
      // 明细列表
      detailTableData: [],
      voidedTableData: [],
      selectedDetailRows: [],
      selectedVoidedRows: [],
      // 明细列表分页
      detailPageNo: 1,
      detailPageSize: 20,
      detailPageCount: 0,
      detailTotal: 0,
      // 已作废列表分页
      voidedPageNo: 1,
      voidedPageSize: 20,
      voidedPageCount: 0,
      voidedTotal: 0,
      
      // 园区选择相关
      gardenPopoverVisible: false,
      // gardenFilterText: '',
      gardenExpandedKeys: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  // computed: {
  //   ...mapGetters({
  //     gardens: 'userGardenList'
  //   }),
    // gardenAreaByStaff() {
    //   let data = JSON.parse(JSON.stringify(this.gardenAreaByStaffOrigin))
    //   if (data && data.length > 0 && data[0].children && data[0].children.length > 0) {
    //     data[0].children.sort((a, b) => {
    //       const aPY = pinyin(a.name, {
    //         style: pinyin.STYLE_FIRST_LETTER
    //       }).map(i => i[0]).join('').toUpperCase()
    //       const bPY = pinyin(b.name, {
    //         style: pinyin.STYLE_FIRST_LETTER
    //       }).map(i => i[0]).join('').toUpperCase()
    //       return aPY.localeCompare(bPY)
    //     })
    //   }
    //   return data
    // },
    // flatGardenList() {
    //   const flatten = (arr) => {
    //     let result = []
    //     arr.forEach(item => {
    //       if (item.children && item.children.length > 0) {
    //         result = result.concat(flatten(item.children))
    //       } else {
    //         result.push(item)
    //       }
    //     })
    //     return result
    //   }
    //   return flatten(this.gardenAreaByStaff)
    // }
  // },
  created() {
    console.log(this.$store.getters)
    this.gardenId = this.$store.getters.gardenId
    this.isFeeManager = this.$store.getters.isFeeManager
    this.getGarden()
    this.getTablelist()
  },
  // watch: {
  //   gardenFilterText(val) {
  //     if (this.$refs.gardenTree) {
  //       this.$refs.gardenTree.filter(val)
  //     }
  //   }
  // },
  methods: {
    getGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.gardenDialist = myGardens

    },
    // 获取列表
    getTablelist() {
      let loading = this.$loading()
      this.$get(
        `/feeBillList?pageNo=${this.pageNo}&pageSize=${this.pageSize}&batchNo=${this.searchBatchNo}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 新增
    add() {
      this.addForm = {
        billPrefix: '',
        batchNo: '',
        startNo: 0,
        endNo: 0,
        gardenId: '',
        remark: ''
      }
      this.isAddDialog = true
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate()
        }
      })
    },
    // 保存新增
    saveAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.addForm.endNo <= this.addForm.startNo) {
            this.$message.error('截止编号必须大于起始编号')
            return false
          }
          let loading = this.$loading()
          this.$post(`/feeBill`, this.addForm).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.isAddDialog = false
                this.commit()
              } else {
                this.$message.error(res.errMsg || '保存失败')
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    clearAddForm() {
      this.isAddDialog = false
    },
    handleAddDialogClosed() {
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields()
      }
    },
    // 编辑
    edit(row) {
      this.editId = row.id
      let loading = this.$loading()
      this.$get(`/feeBill/${this.editId}`).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.editForm = res.data
            this.editForm.createTimeStr = this.$options.filters.timeYMD(res.data.createTime)
            this.loadBillStats()
            this.loadBillDetails()
            this.isEditDialog = true
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 加载统计信息
    loadBillStats() {
      this.$get(`/feeBillStats/${this.editId}`).then(
        (res) => {
          if (res && res.errCode === 0) {
            this.billStats = {
              total: res.total || 0,
              used: res.used || 0,
              totalAmount: res.totalAmount || '0.00'
            }
          }
        },
        (error) => {
          this.$message.error(error)
        }
      )
    },
    // 加载明细列表（所有票据，排除已作废）
    loadBillDetails() {
      // status=-1 表示查询非已作废的（status != 2）
      this.$get(`/feeBillDetailList?feeBillId=${this.editId}&status=-1&pageNo=${this.detailPageNo}&pageSize=${this.detailPageSize}`).then(
        (res) => {
          if (res && res.errCode === 0) {
            this.detailTableData = res.list
            this.detailPageCount = res.pageCount
            this.detailTotal = res.total
          }
        },
        (error) => {
          this.$message.error(error)
        }
      )
    },
    // 加载已作废列表
    loadVoidedDetails() {
      this.$get(`/feeBillDetailList?feeBillId=${this.editId}&status=2&pageNo=${this.voidedPageNo}&pageSize=${this.voidedPageSize}`).then(
        (res) => {
          if (res && res.errCode === 0) {
            this.voidedTableData = res.list
            this.voidedPageCount = res.pageCount
            this.voidedTotal = res.total
          }
        },
        (error) => {
          this.$message.error(error)
        }
      )
    },
    handleTabClick(tab) {
      if (tab.name === 'billDetail') {
        this.detailPageNo = 1
        this.voidedPageNo = 1
        this.loadBillDetails()
        if (this.detailTab === 'voided') {
          this.loadVoidedDetails()
        }
      }
    },
    handleDetailTabClick(tab) {
      // 切换明细tab时重新加载数据
      if (tab.name === 'all') {
        this.detailPageNo = 1
        this.loadBillDetails()
      } else if (tab.name === 'voided') {
        this.voidedPageNo = 1
        this.loadVoidedDetails()
      }
    },
    // 所有票据分页
    handleDetailCurrentChange(val) {
      this.detailPageNo = val
      this.loadBillDetails()
    },
    handleDetailSizeChange(val) {
      this.detailPageNo = 1
      this.detailPageSize = val
      this.loadBillDetails()
    },
    // 已作废分页
    handleVoidedCurrentChange(val) {
      this.voidedPageNo = val
      this.loadVoidedDetails()
    },
    handleVoidedSizeChange(val) {
      this.voidedPageNo = 1
      this.voidedPageSize = val
      this.loadVoidedDetails()
    },
    // 保存编辑
    saveEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$patch(`/feeBill/${this.editId}`, {
            batchNo: this.editForm.batchNo,
            billPrefix: this.editForm.billPrefix,
            startNo: this.editForm.startNo,
            endNo: this.editForm.endNo,
            gardenId: this.editForm.gardenId,
            remark: this.editForm.remark
          }).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.loadBillStats()
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    saveEditAndReturn() {
      this.saveEdit()
      setTimeout(() => {
        this.isEditDialog = false
        this.commit()
      }, 500)
    },
    clearEditForm() {
      this.isEditDialog = false
    },
    handleEditDialogClosed() {
      this.activeTab = 'billInfo'
      this.detailTab = 'all'
      this.selectedDetailRows = []
      this.selectedVoidedRows = []
    },
    // 作废票据
    voidBillDetail() {
      if (this.selectedDetailRows.length === 0) {
        this.$message.warning('请选择要作废的票据')
        return
      }
      this.$confirm('确定要作废选中的票据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let loading = this.$loading()
        let promises = this.selectedDetailRows.map(row => {
          return this.$patch(`/feeBillDetail/${row.id}/void`)
        })
        Promise.all(promises).then(
          (results) => {
            loading.close()
            this.$message.success('作废成功')
            this.selectedDetailRows = []
            // 重新加载数据，保持当前分页
            this.loadBillDetails()
            this.loadBillStats()
            // 如果当前在已作废tab，也重新加载已作废列表
            if (this.detailTab === 'voided') {
              this.loadVoidedDetails()
            }
          },
          (error) => {
            loading.close()
            this.$message.error('作废失败')
          }
        )
      })
    },
    // 取消作废
    cancelVoidBillDetail() {
      if (this.selectedVoidedRows.length === 0) {
        this.$message.warning('请选择要取消作废的票据')
        return
      }
      this.$confirm('确定要取消作废选中的票据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let loading = this.$loading()
        let promises = this.selectedVoidedRows.map(row => {
          return this.$patch(`/feeBillDetail/${row.id}/cancelVoid`)
        })
        Promise.all(promises).then(
          (results) => {
            loading.close()
            this.$message.success('取消作废成功')
            this.selectedVoidedRows = []
            // 重新加载数据，保持当前分页
            this.loadVoidedDetails()
            this.loadBillStats()
            // 重新加载所有票据列表
            this.loadBillDetails()
          },
          (error) => {
            loading.close()
            this.$message.error('取消作废失败')
          }
        )
      })
    },
    handleDetailSelectionChange(val) {
      this.selectedDetailRows = val
    },
    handleVoidedSelectionChange(val) {
      this.selectedVoidedRows = val
    },
    // 删除
    deletetable(id) {
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        let loading = this.$loading()
        this.$delete(`/feeBill/${id}`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit()
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    detailIndexMethod(index) {
      return (this.detailPageNo - 1) * this.detailPageSize + index + 1
    },
    voidedIndexMethod(index) {
      return (this.voidedPageNo - 1) * this.voidedPageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 园区树相关方法
    filterGardenNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleGardenNodeClick(data) {
      this.addForm.gardenId = data.id
      this.gardenPopoverVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.feeBill {
  .el-dialog .el-form .el-form-item {
    margin-right: 0;
    margin-bottom: 15px !important;
    text-align: left;
  }
  .edit-header {
    margin-bottom: 20px;
    .stats-info {
      font-size: 14px;
      color: #333;
    }
  }
  .el-tabs.el-tabs--top{
    background-color: #fff;
    ::v-deep .el-tabs__content {
      padding-top: 30px !important;
    }
    ::v-deep .el-tabs__nav-wrap {
      position: static;
      background-color: transparent;
      max-width: none;
      z-index: none;
      border-bottom: none;
    }
  }
  ::v-deep .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item {
      border-left: none;
      border-right: none  !important;;
    }
}
</style>
